import { createStore } from '@stencil/store';
import { string } from 'prop-types';
import { SearchResponseEntry, BankBranch } from '../../types/global'; // eslint-disable-line import/extensions

/**
 * Careful! Only include stuff that is IDENTICAL for BankSearch-Full and BankSearch-Light!
 * If used on the same page, Search-Light might set "hasForm" or "isOverlayVisible" to false,
 * making Search-Full believe it has no form or should hide the overlay. Use PROPS for stuff
 * that would cause conflicts with the other component.
 */
const store = createStore({
  assetsUrl: '',
  errorMessage: '',
  hasForm: false,
  formName: string,
  google: null as typeof google,
  selectedPlaceName: '',
  selectedBank: null as SearchResponseEntry,
  selectedPlaceLocation: null as google.maps.LatLng,
  hoveredResultIndex: null as number,
  selectedResultIndex: null as number,
  resultsTotal: null as SearchResponseEntry[],
  resultsVisible: null as SearchResponseEntry[],
  resultsVisibleCount: 5,
  isOverlayVisible: false,
  isSliderCondensed: false,
  activeFilterValue: '',
  availableFilters: [
    { value: '', default: true },
    { value: 'vr', default: false },
    { value: 'psd', default: false },
    { value: 'sparda', default: false },
    { value: 'bbbank', default: false },
  ] as BankBranch[],
  loadMore: null as () => void,
  /**
   * Temporarily disable
   * - saving to localStorage
   * - tracking bank select / change
   * while restoring previously saved search values.
   */
  isCurrentlyRestoring: false,
  isRestoredDataFromLocalstorage: false,
});

/* eslint-disable no-use-before-define */
store.onChange('resultsTotal', () => {
  updateResultsVisible();
});
store.onChange('resultsVisibleCount', () => {
  updateResultsVisible();
});
store.onChange('isOverlayVisible', () => {
  const event = new CustomEvent('overlayVisibilityChange', {
    detail: { isVisible: store.state.isOverlayVisible },
    bubbles: true,
    composed: true,
  });
  window.dispatchEvent(event);
});

function updateResultsVisible() {
  const filteredResults = [...store.state.resultsTotal]?.filter(
    (bank) =>
      !store.state.activeFilterValue ||
      bank.bankType === store.state.activeFilterValue
  );

  store.state.resultsVisible = filteredResults.slice(
    0,
    store.state.resultsVisibleCount
  );
}

// eslint-disable-next-line import/no-default-export
export default store;
